import { StatusChip } from "@msys/ui";
import { Check as CheckIcon } from "@mui/icons-material";
import { alpha, SxProps, Theme } from "@mui/material";
import { useTranslate } from "@tolgee/react";

/** Tints a pinned current-selection row on top of its `selected` outline. */
export const CURRENT_SELECTION_ROW_SX: SxProps<Theme> = {
  bgcolor: theme => alpha(theme.palette.primary.main, 0.03),
};

export const CurrentSelectionChip = ({
  variant = "selected",
}: {
  variant?: "selected" | "filledByHand";
}) => {
  const { t } = useTranslate(["Global", "QuoteItem"]);
  return (
    <StatusChip
      color="primary"
      icon={<CheckIcon fontSize="small" />}
      label={
        variant === "selected"
          ? t("Selected", { ns: "Global" })
          : t("Filled by hand", { ns: "QuoteItem" })
      }
    />
  );
};
